import { Card, Group, Stack, Text } from '@mantine/core';
import { Eyebrow } from './Eyebrow';
import { brand, forest, shadows } from '@/theme/theme';

export interface StatCardProps {
  label: string;
  value: string | number;
  unit?: string;
  sub?: string;
  /** Gradient forest card with the figure in forest 2; at most one per row. */
  accent?: boolean;
  testId?: string;
}

/** Key figure card: eyebrow label, bold italic figure, unit, sub-line (frontend-design.md §6). */
export function StatCard({ label, value, unit, sub, accent = false, testId }: StatCardProps) {
  return (
    <Card
      data-testid={testId}
      radius="xl"
      shadow="md"
      style={
        accent
          ? { background: `linear-gradient(135deg, ${forest[8]}, ${forest[6]})`, borderColor: forest[4], boxShadow: shadows.accent }
          : undefined
      }
    >
      <Stack gap={6}>
        <Eyebrow onDark={accent}>{label}</Eyebrow>
        <Group gap={6} align="baseline">
          <Text fz={30} fw={700} fs="italic" c={accent ? forest[2] : brand.text} lh={1.1}>
            {value}
          </Text>
          {unit && (
            <Text fz={14} c={accent ? brand.onDarkMuted : brand.textMuted}>
              {unit}
            </Text>
          )}
        </Group>
        {sub && (
          <Text fz={12} c={accent ? brand.onDarkMuted : brand.textMuted}>
            {sub}
          </Text>
        )}
      </Stack>
    </Card>
  );
}
